import ReactGA from "react-ga4";

const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID; // Store your GA4 tracking ID in .env file
let isInitialized = false; // Prevent multiple initializations
const ISANALYTICS = process.env.REACT_APP_ISANALYTICS === "true" ? true : false;
const expireTime = 63072000;

class AnalyticsPageTracker {
  // initialize GA
  static init() {
    if (!isInitialized && ISANALYTICS && GA_TRACKING_ID) {
      // console.log("GA Initialized with ID:", GA_TRACKING_ID);
      ReactGA.initialize(GA_TRACKING_ID, {
        gaOptions: {
          cookieExpires: expireTime,
          storage: "none",
        },
        gtagOptions: {
          cookie_flags: "SameSite=None; Secure", // Prevents frequent updates
        },
        testMode: !ISANALYTICS,
      });
      isInitialized = true;
    }
  }

  // track page views
  static trackPageView(path: string) {
    if (isInitialized) {
      ReactGA.send({ hitType: "pageview", page: path });
    }
  }
}

export default AnalyticsPageTracker;
